__turbopack_context__.v({
  "highlight": "BundleMatrix-module__dLwFVG__highlight",
});
